<label [attr.for]="id" [class]="styleClass" [ngStyle]="style" [class.invalid]="invalid">{{ text }}</label>
